<div class="fluid-container">
  <h2 class="experience">
    <i class="bi bi-briefcase"></i>
    Experience
  </h2>

  <span class="info-text">
    <span class="optional-text">Optional:</span>
    <span class="desc-text">
      No experiences yet? That's okay! You can skip this section — your projects
      and skills will speak for you.
    </span>
  </span>

  <div class="no-box" *ngIf="!showForm && !hasExperienceData">
    <p>No experiences added yet</p>

    <span class="add-btn-intern" (click)="showForm = true">
      + Add Internship / Experience
    </span>
  </div>

  <div class="form-box" *ngIf="showForm">
    <div class="top-actions" *ngIf="experience.length === 1">
      <button type="button" class="delete-btn" (click)="closeForm()">
        <i class="bi bi-trash-fill"></i>
      </button>
    </div>

    <form [formGroup]="userProfileForm">
      <div formArrayName="experience">
        <div
          *ngFor="let edu of experience.controls; let i = index"
          [formGroupName]="i"
          class="form-card mb-3"
        >
          <button
            type="button"
            class="remove"
            (click)="removeExperience(i)"
            *ngIf="experience.length > 1"
          >
            <i class="bi bi-trash-fill"></i>
          </button>

          <h3 class="section-title">
            <i class="bi bi-school"></i>

            Experience {{ i + 1 }}
          </h3>

          <div class="form-grid">
            <div class="form-group">
              <label>Company Name</label>
              <input
                type="text"
                formControlName="company"
                placeholder="e.g. Google"
              />
            </div>

            <div class="form-group">
              <label>Location</label>
              <input
                type="text"
                formControlName="location"
                placeholder="e.g. Mumbai, India"
              />
            </div>

            <div class="form-group full-width">
              <label>Role/Title</label>
              <input
                type="text"
                formControlName="role"
                placeholder="e.g. Software Intern"
              />
            </div>

            <div class="form-group">
              <label>Start Date</label>
              <div class="date-row">
                <select formControlName="startMonth">
                  <option value="" disabled selected hidden>Month</option>
                  <option *ngFor="let m of months" [value]="m">{{ m }}</option>
                </select>
                <select formControlName="startYear">
                  <option value="" disabled selected hidden>Year</option>
                  <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
                </select>
              </div>
            </div>

            <div class="form-group">
              <label>End Date</label>
              <div class="date-row">
                <select formControlName="endMonth">
                  <option value="" disabled selected hidden>Month</option>
                  <option value="Present" *ngIf="isCurrentlyWorking(i)">
                    Present
                  </option>

                  <ng-container *ngIf="!isCurrentlyWorking(i)">
                    <option *ngFor="let m of months" [value]="m">
                      {{ m }}
                    </option>
                  </ng-container>
                </select>
                <select
                  formControlName="endYear"
                  [disabled]="isCurrentlyWorking(i)"
                >
                  <option value="" disabled selected hidden>Year</option>
                  <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
                </select>
              </div>
              <div class="checkbox">
                <input
                  type="checkbox"
                  formControlName="currently_working"
                  (change)="onCurrentlyWorkingChange($event, i)"
                />Currently Working
              </div>
               <div class="text-danger smaller-text"
                  *ngIf="experience.at(i).errors?.['invalidDateRange'] &&
                  (getControl(i, 'endMonth')?.dirty || getControl(i, 'endYear')?.dirty)">
                  End date cannot be earlier than start date
                </div>
            </div>

            <div class="form-group full-width">
              <label>Description</label>
              <textarea
                type="text"
                formControlName="description"
                row="4"
                placeholder="e.g. What did you do? what did you learn?"
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      <button type="button" class="add-btn" (click)="addExperience()">
        + Add Another Experience
      </button>
    </form>
  </div>
</div>
